export default (domain, action, states = ['REQUEST', 'SUCCESS', 'FAILURE']) => {
  return states.reduce((requests, state) => {
    requests[state] = `${domain}::${action}::${state}`;
    return requests;
  }, {});
};
